module.exports = __webpack_public_path__ + "static/media/1.5077cf34.png";